var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    viewBox: "0 0 17.272 20.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-marker",
    transform: "translate(-1.945 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5280",
    "data-name": "Path 5280",
    d: "M11.436,6a3.436,3.436,0,1,0,3.436,3.436A3.436,3.436,0,0,0,11.436,6Zm0,5.153a1.718,1.718,0,1,1,1.718-1.718A1.718,1.718,0,0,1,11.436,11.153Z",
    transform: "translate(-0.854 -0.847)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5281",
    "data-name": "Path 5281",
    d: "M10.581,20.613a4.527,4.527,0,0,1-3.7-1.89c-3.273-4.515-4.933-7.91-4.933-10.089a8.636,8.636,0,1,1,17.272,0c0,2.18-1.66,5.574-4.933,10.089A4.527,4.527,0,0,1,10.581,20.613Zm0-18.74A6.771,6.771,0,0,0,3.818,8.636c0,1.726,1.626,4.919,4.577,8.989a2.7,2.7,0,0,0,4.372,0c2.951-4.07,4.577-7.263,4.577-8.989a6.771,6.771,0,0,0-6.763-6.763Z",
    fill: "#bbc6d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.35e6b1fb.svg";
export { ForwardRef as ReactComponent };